// Lib
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

// Utils
import { shouldShowTitleSuggestion } from '../suggestion/title/titleSuggestionUtils';
import { shouldShowDeleteTasksSuggestion } from './suggestion/deleteTasks/deleteTasksSuggestionUtils';
import { useTranslator } from '../../components/i18n/useTranslator';

// Components
import FeatureSuggestions from '../suggestion/FeatureSuggestions';
import TitleSuggestion from '../suggestion/title/TitleSuggestion';
import DeleteTasksSuggestion from './suggestion/deleteTasks/DeleteTasksSuggestion';

// Constants
import { FEATURE_SUGGESTIONS } from '../suggestion/suggestionConstants';

const TaskListFeatureSuggestions = (props) => {
    // Get translator for task list feature suggestions
    const translate = useTranslator('elements', 'elementTypes.taskList.featureSuggestions');

    const addTitleQuestion = translate('title.question');
    const deleteTasksQuestion = translate('deleteTasks.question');

    const suggestions = useMemo(() => [
        {
            feature: FEATURE_SUGGESTIONS.TITLE,
            shouldShow: shouldShowTitleSuggestion,
            question: addTitleQuestion,
            component: TitleSuggestion,
        },
        {
            feature: FEATURE_SUGGESTIONS.DELETE_COMPLETED_TASKS,
            shouldShow: shouldShowDeleteTasksSuggestion,
            question: deleteTasksQuestion,
            component: DeleteTasksSuggestion,
        },
    ], [addTitleQuestion, deleteTasksQuestion]);

    return <FeatureSuggestions {...props} possibleSuggestions={suggestions} />;
};

TaskListFeatureSuggestions.propTypes = {
    element: PropTypes.object,
    isEditable: PropTypes.bool,
};

export default TaskListFeatureSuggestions;
